import React from 'react';
import { VideosContext } from '../context/entity-collections';
export var useVideos = function () {
  return React.useContext(VideosContext) || [];
};